import { Component, OnInit } from '@angular/core';

import { GlobalService } from '../services/global.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';

import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.css']
})

export class AdminComponent implements OnInit {

    public logoImage = localStorage.getItem('logoPhotoPath') && localStorage.getItem('logoPhotoPath').length > 1 ? 'https://web234.hvsfinancial.com/portal-shared/' + localStorage.getItem('logoPhotoPath') : 'https://web234.hvsfinancial.com/assets/images/temp/logo.png';
    public advisor: any;
    public organization: any = {
        Name: '',
        Address: '',
        Number: '',
        Email: '',
        DisclosureSS: '',
        DisclosureHC: '',
        DisclosureMMT: '',
        DisclosureLTC: ''
    };

    public error: any;
    private selectedOrganization: number;

    constructor(private globalService: GlobalService, private router: Router, private snackbarService: SnackBarService) {

    }

    public isAxa: boolean;
    public isOAUser: boolean;
    public isOAAdmin: boolean;

    private organizations: any[];

    ngOnInit() {
        if (localStorage.getItem('roleId') != '2' && localStorage.getItem('roleId') != '1') {
            this.router.navigate(['/home']);
        } else {
            this.isAxa = (Number(localStorage.getItem('orgID')) === 421 || Number(localStorage.getItem('parentID')) === 421) ? true : false;
            this.isOAUser = (Number(localStorage.getItem('orgID')) === 2 || Number(localStorage.getItem('parentID')) === 2) ? true : false;
            this.isOAAdmin = (Number(localStorage.getItem('orgID')) === 2 && (Number(localStorage.getItem('roleId')) === 2)) ? true : false;
            this.selectedOrganization = Number(localStorage.getItem("orgID"));
            this.getOrganizationsData();
            this.getData();
        }
    }

    getData() {
        this.globalService.getAdvisorData(Number(localStorage.getItem("userId")))
            .subscribe(
                advisor => {
                    this.advisor = advisor;
                    
                    this.globalService.getOrganizationData(this.selectedOrganization)
                        .subscribe(
                            organization => {
                                this.organization = organization;

                                if (organization) {
                                    this.organization.DisclosureSS = this.organization.DisclosureSS ? this.organization.DisclosureSS.replace(new RegExp('<br />', 'g'), '\n') : '';
                                    this.organization.DisclosureMMT = this.organization.DisclosureMMT ? this.organization.DisclosureMMT.replace(new RegExp('<br />', 'g'), '\n') : '';
                                    this.organization.DisclosureHC = this.organization.DisclosureHC ? this.organization.DisclosureHC.replace(new RegExp('<br />', 'g'), '\n') : '';
                                    this.organization.DisclosureLTC = this.organization.DisclosureLTC ? this.organization.DisclosureLTC.replace(new RegExp('<br />', 'g'), '\n') : '';

                                    if (typeof this.organization.LogoPath != 'object')
                                        this.logoImage = "https://web234.hvsfinancial.com/portal-shared/" + this.organization.LogoPath;
                                    else
                                        this.logoImage = "https://web234.hvsfinancial.com/portal-shared/" + localStorage.getItem('logoPhotoPath');
                                }
                            },
                            error => this.error = <any>error);
                },
                error => this.error = <any>error);
    }

    displayPreparedLogo(e) {
        const reader = new FileReader();
        this.file = e.target.files[0];
        reader.readAsDataURL(this.file);

        reader.onload = (test: any) => {
            this.logoImage = test.target.result;
        }
    }

    public file: File;

    uploadOrgLogo() {
        //this.file = e.target.files[0];
        let formData: FormData = new FormData();
        var date = new Date().getTime() / 1000;

        formData.append('uploadFile', this.file, this.advisor.OrganizationID + '_' + date + '_logo' + this.file.name.substring(this.file.name.lastIndexOf('.'), this.file.name.length));
        formData.append('Email', this.advisor.Email);
        formData.append('UserID', this.advisor.ID.toString());

        this.globalService.uploadOrgLogo(formData)
            .subscribe(
                data => {
                    localStorage.setItem('logoPhotoPath', data._body);
                    this.logoImage = "https://web234.hvsfinancial.com/portal-shared/" + localStorage.getItem('logoPhotoPath');
                },
                error => this.error = <any>error);
    }

    save() {
        if (this.file)
            this.uploadOrgLogo();

        this.globalService.updateOrgInfo(this.organization)
            .subscribe(
                data => {

                    this.snackbarService.add('Your organization has been updated.', 0);
                },
                error => this.error = <any>error);
    }

    getOrganizationsData() {
        this.globalService.getOrganizationsData()
            .subscribe(organizations => {
                var temp = [];

                organizations.forEach((org) => {
                    if (org.Name.length > 0) {
                        org.Name = org.Name.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
                        temp.push(org);
                    }
                });

                temp = temp.sort((a, b) => {
                    if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
                    if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
                    return 0;
                });

                this.organizations = temp;

            },
                error => this.error = <any>error);
    }

    cancel() {

    }

    handleOrgSelected() {
        this.getData();
    }
}
